import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'
import * as rd from "diacritics"

import {
  Table,
  Jumbotron,
  Button,
  Tabs,
  Tab,
  Row,
  Grid,
  Col,
  Modal,
  Image,
  Panel,
  ButtonGroup,
  FormControl,
  FormGroup,
  ControlLabel,
  Label
} from 'react-bootstrap';

import If from "../../utils/If"

import Loader from 'react-loader-advanced';

import '../../statics/css/table-exercises.css'

import videoPlayerIcon from '../../statics/images/video_player.svg'

//DAO
import { exercisesByCategoryList, exercisesList } from '../../dao-firebase/training-daofirebae'

import { categorysListUtils } from "../../utils/categorys-exercises"

class TableAllExercises extends Component {

  constructor(props) {
    super(props);

    this.state = {

      category: this.props.category,
      exercises: [],
      idsExercisesSelcteds: [],

    };

  }

  componentDidMount() {

  }

  componentWillMount() {

    this.setState({
      exercises: this.props.exercises,
    }, () => {
      console.log(this.state.exercises)
    })
    // exercisesList((response) => {

    //   this.setState({
    //     exercises: response,
    //     lastCategory: response[0].data.category
    //   }, () => {

    //     console.log(this.state.exercises)
    //   })
    // })
  }

  verifySearch(obj) {

    let nameObjFormat = rd.remove(obj.name.toLowerCase());
    let searchFormat = rd.remove(this.props.search.toLowerCase());
    return nameObjFormat.includes(searchFormat);
  }

  selectExercise(e, data) {

    console.log("DATA: " + JSON.stringify(data))
    if (e.target.className.includes("selected")) {
      e.target.className = e.target.className.toString().replace(" selected", "");
    } else {
      e.target.className = e.target.className + " selected";
    }

    this.props.handleUpdateExercisesSelected(
      Array.from(ReactDOM.findDOMNode(this.tbody).getElementsByClassName('exercise-name selected')));

  }

  verifyAlreadyInSection(id_test) {

    for (let i = 0; i < this.props.sections.length; i++) {

      let sectionLoop = this.props.sections[i];

      if (sectionLoop.exercises) {

        for (let j = 0; j < sectionLoop.exercises.length; j++) {

          let exerciseLoop = sectionLoop.exercises[j];

          //console.log("COMPARANDO: " + exerciseLoop.id + " com: " + id_test);
          if (exerciseLoop.id == id_test) {
            return true;
          }

        }
      }

    }
    return false;
  }

  renderExercises() {

    let lastCategory = '';

    let exerciseItems = [];

    for (let i = 0; i < this.state.exercises.length; i++) {

      let exercise = this.state.exercises[i];

      if (exercise.data.category != lastCategory && this.props.search == '') {

        //console.log(exercise.data.category);
        let thatCategory = '';
        for (let i = 0; i < categorysListUtils.length; i++) {
          console.log("COMPARE: " + categorysListUtils[i].key + "==" + exercise.data.category);
          if (categorysListUtils[i].key == exercise.data.category) {
            thatCategory = categorysListUtils[i].name;
            break;
          }
        }

        lastCategory = exercise.data.category;
        exerciseItems.push(
          <tr className="item-exercises-category">

            <td className="exercise-category">
              <p>{thatCategory}</p>
            </td>

          </tr>
        )
      }

      //console.log(exercise.data.name + " INCLUDES: " + this.props.search + "? " + exercise.data.name.includes(this.props.search))

      //if ((this.props.search == '' || this.verifySearch(exercise.data)) && !this.verifyAlreadyInSection(exercise.id)) {
      //Agora pode colocar o mesmo exercício duas vezes
      if ((this.props.search == '' || this.verifySearch(exercise.data))) {

        exerciseItems.push(
          <tr className="item-exercises-list">

            <td className="exercise-name" id={JSON.stringify(exercise)} onClick={(e) => this.selectExercise(e, exercise.data)}>
              {exercise.data.name}
            </td>

          </tr>
        );
      }

    }

    return exerciseItems;

  }

  render() {

    return (
      <div>
        <Table className={this.props.customClass ? this.props.customClass : ""} responsive>
          {/* <thead>
            <tr>
              <th>Vídeo</th>
              <th>Nome</th>
              <th>Descrição</th>
            </tr>
          </thead> */}
          <tbody className="body-all" ref={(tbody) => { this.tbody = tbody; }}>
            {this.renderExercises()}
          </tbody>
        </Table>
      </div >
    );
  }
}

export default TableAllExercises;



// WEBPACK FOOTER //
// src/components/treinos/table-all-exercises.js